module.exports = __webpack_public_path__ + "img/41d-config-formularios-referencia.cfb986db.png";